export const siteTypeEnum = {
    INTERNAL: 1,
    EXTERNAL: 2,
    SPECIAL: 3,
    TRAINING: 4,
};
